// ========== Toast Notifications ==========
window.showToast = function (message, type) {
  type = type || 'success';
  var container = document.getElementById('ToastContainer');
  if (!container) return;
  var toast = document.createElement('div');
  toast.className = 'toast toast--' + type;
  toast.textContent = message;
  container.appendChild(toast);
  // Trigger animation
  requestAnimationFrame(function () {
    toast.classList.add('toast--visible');
  });
  setTimeout(function () {
    toast.classList.remove('toast--visible');
    toast.addEventListener('transitionend', function () {
      toast.remove();
    });
  }, 3000);
};

// Global JS for basic theme functionality
document.addEventListener('DOMContentLoaded', () => {
  console.log('Mega Pizza theme loaded.');
  adjustFixedLayout();
  window.addEventListener('resize', adjustFixedLayout);

  // Listen for system theme changes (when no manual preference)
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    if (!localStorage.getItem('theme')) {
      document.documentElement.setAttribute('data-theme', e.matches ? 'dark' : 'light');
    }
  });

  // Show/hide sticky cart button based on cart count
  updateStickyCartBtn();
});

// Dark mode toggle
window.toggleDarkMode = function () {
  const html = document.documentElement;
  const isDark = html.getAttribute('data-theme') === 'dark';
  const newTheme = isDark ? 'light' : 'dark';
  html.setAttribute('data-theme', newTheme);
  localStorage.setItem('theme', newTheme);
};

// Dynamically adjust category bar position based on actual header height
function adjustFixedLayout() {
  const announcement = document.querySelector('.announcement-bar');
  const header = document.querySelector('.header');
  const categories = document.querySelector('.restaurant-categories');
  const deliveryDropdown = document.getElementById('DeliveryZonesDropdown');
  if (!header) return;

  const announcementHeight = announcement ? announcement.offsetHeight : 0;
  const headerHeight = header.offsetHeight;

  // Push header below announcement bar
  header.style.top = announcementHeight + 'px';

  if (categories) {
    var catTop = announcementHeight + headerHeight;
    categories.style.top = catTop + 'px';
    document.body.style.paddingTop = (catTop + categories.offsetHeight) + 'px';

    // Position delivery dropdown right below the categories bar
    if (deliveryDropdown) {
      deliveryDropdown.style.top = (catTop + categories.offsetHeight) + 'px';
    }
  } else {
    document.body.style.paddingTop = (announcementHeight + headerHeight) + 'px';

    if (deliveryDropdown) {
      deliveryDropdown.style.top = (announcementHeight + headerHeight) + 'px';
    }
  }
}

// Sidebar Menu Logic
window.openSidebar = function () {
  const sidebar = document.getElementById('SidebarMenu');
  const overlay = document.getElementById('SidebarOverlay');

  if (sidebar && overlay) {
    sidebar.classList.add('sidebar--open');
    overlay.classList.add('sidebar-overlay--visible');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }
};

window.closeSidebar = function () {
  const sidebar = document.getElementById('SidebarMenu');
  const overlay = document.getElementById('SidebarOverlay');

  if (sidebar && overlay) {
    sidebar.classList.remove('sidebar--open');
    overlay.classList.remove('sidebar-overlay--visible');
    document.body.style.overflow = ''; // Restore background scrolling
  }
};

// Delivery Zones Dropdown Logic
window.toggleDeliveryZones = function () {
  const dropdown = document.getElementById('DeliveryZonesDropdown');
  const btn = document.querySelector('.delivery-zones-btn');

  if (dropdown) {
    const isOpen = dropdown.classList.toggle('delivery-dropdown--open');
    dropdown.setAttribute('aria-hidden', !isOpen);
    if (btn) btn.setAttribute('aria-expanded', isOpen);
  }
};

// ========== Cart Drawer Logic ==========

window.openCartDrawer = function () {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  drawer.classList.add('cart-drawer--open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  updateMinOrderBar();
};

window.closeCartDrawer = function () {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  drawer.classList.remove('cart-drawer--open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
};

// ========== Minimum Order Bar ==========
let _deliveryZones = [];

function loadDeliveryZones() {
  var el = document.getElementById('DeliveryZonesData');
  if (el) {
    try { _deliveryZones = JSON.parse(el.textContent); } catch (e) { _deliveryZones = []; }
  }
  // Convert minimum to cents
  _deliveryZones.forEach(function (z) {
    z.minCents = (parseFloat(z.minimum) || 0) * 100;
  });
}

function getSelectedZone() {
  var idx = localStorage.getItem('mega_delivery_zone');
  if (idx !== null && _deliveryZones[parseInt(idx, 10)]) {
    return { index: parseInt(idx, 10), zone: _deliveryZones[parseInt(idx, 10)] };
  }
  return null;
}

window.selectDeliveryZone = function (idx) {
  if (idx === '' || idx === undefined) return;
  localStorage.setItem('mega_delivery_zone', idx);
  closeZoneModal();
  updateMinOrderBar();
};

window.openZoneModal = function () {
  if (_deliveryZones.length === 0) loadDeliveryZones();
  var modal = document.getElementById('ZonePickerModal');
  var list = document.getElementById('ZonePickerList');
  if (!modal || !list) return;

  var html = '';
  _deliveryZones.forEach(function (z, i) {
    html += '<button class="zone-picker__zone zone-picker__zone--' + z.color + '" onclick="selectDeliveryZone(' + i + ')">';
    html += '<div class="zone-picker__zone-info">';
    html += '<span class="zone-picker__zone-name">' + z.name + '</span>';
    html += '<span class="zone-picker__zone-min">Min. ' + z.minimum + '.–</span>';
    html += '</div>';
    if (z.cities) {
      html += '<p class="zone-picker__zone-cities">' + z.cities + '</p>';
    }
    html += '</button>';
  });
  list.innerHTML = html;
  modal.style.display = '';
  modal.setAttribute('aria-hidden', 'false');
};

window.closeZoneModal = function () {
  var modal = document.getElementById('ZonePickerModal');
  if (modal) {
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
  }
};

window.updateMinOrderBar = function () {
  var bar = document.getElementById('CartMinOrderBar');
  if (!bar) return;
  if (_deliveryZones.length === 0) loadDeliveryZones();
  if (_deliveryZones.length === 0) { bar.style.display = 'none'; return; }

  var selected = getSelectedZone();

  // If no zone selected, show compact link to open zone picker
  if (!selected) {
    var html = '<div class="cart-min-order__select-row" onclick="openZoneModal()">';
    html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>';
    html += '<span>Choisir votre zone de livraison</span>';
    html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;opacity:0.5;"><path d="m9 18 6-6-6-6"/></svg>';
    html += '</div>';
    bar.innerHTML = html;
    bar.style.display = '';
    return;
  }

  // Compute cart total from DOM
  var totalEl = document.getElementById('CartDrawerTotal');
  var cartTotal = totalEl ? parsePriceText(totalEl.textContent) : 0;
  var min = selected.zone.minCents;

  if (min <= 0) { bar.style.display = 'none'; return; }

  var pct = Math.min(100, Math.round((cartTotal / min) * 100));
  var remaining = min - cartTotal;

  var html = '<div class="cart-min-order__header">';
  html += '<span class="cart-min-order__text">';
  if (remaining > 0) {
    html += 'Encore ' + formatMoney(remaining) + ' pour la livraison';
  } else {
    html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:3px;"><path d="M20 6 9 17l-5-5"/></svg>Minimum atteint !';
  }
  html += '</span>';
  html += '<button class="cart-min-order__change" onclick="localStorage.removeItem(\'mega_delivery_zone\');updateMinOrderBar()">Changer</button>';
  html += '</div>';
  html += '<div class="cart-min-order__bar"><div class="cart-min-order__fill cart-min-order__fill--' + (remaining > 0 ? 'pending' : 'ok') + '" style="width:' + pct + '%"></div></div>';

  bar.innerHTML = html;
  bar.style.display = '';
};

// ========== Supplements Data ==========
let _supplementsData = [];
let _supplementPizzaVariantId = null;
let _supplementPizzaTitle = '';
let _supplementPizzaPrice = 0;

function loadSupplementsData() {
  const el = document.getElementById('SupplementsData');
  if (el) {
    try { _supplementsData = JSON.parse(el.textContent); } catch (e) { _supplementsData = []; }
  }
}

function hasSupplements() {
  if (_supplementsData.length === 0) loadSupplementsData();
  return _supplementsData.length > 0;
}

// ========== Per-product Supplement Rules ==========
let _productSupplementRules = null;

function loadProductSupplementRules() {
  if (_productSupplementRules !== null) return;
  var el = document.getElementById('ProductSupplementRules');
  if (el) {
    try { _productSupplementRules = JSON.parse(el.textContent); } catch (e) { _productSupplementRules = {}; }
  } else {
    _productSupplementRules = {};
  }
}

function getProductSupplementRule(handle) {
  loadProductSupplementRules();
  return _productSupplementRules[handle] || null;
}

// ========== Supplement Modal ==========

window.openSupplementModal = function (variantId, pizzaTitle, pizzaPrice, pizzaVariantTitle, supplementsOverride, modalTitle) {
  // Use override supplements if provided, otherwise fall back to global pizza supplements
  var supplementsToUse;
  if (supplementsOverride) {
    supplementsToUse = supplementsOverride;
  } else {
    if (_supplementsData.length === 0) loadSupplementsData();
    supplementsToUse = _supplementsData;
  }
  if (supplementsToUse.length === 0) return false; // no supplements configured

  _supplementPizzaVariantId = parseInt(variantId, 10);
  _supplementPizzaTitle = pizzaTitle;
  _supplementPizzaPrice = pizzaPrice;

  const modal = document.getElementById('SupplementModal');
  if (!modal) return false;

  // Set modal heading
  var headingEl = document.getElementById('SupplementModalHeading');
  if (headingEl) headingEl.textContent = modalTitle || 'Personnalisez votre pizza';

  // Set product name (include size if available)
  var displayName = pizzaTitle;
  if (pizzaVariantTitle && pizzaVariantTitle !== 'Default Title') {
    displayName += ' (' + pizzaVariantTitle + ')';
  }
  document.getElementById('SupplementModalPizzaName').textContent = displayName;

  // Build supplement list grouped by category
  const listEl = document.getElementById('SupplementModalList');
  listEl.innerHTML = '';

  // Group supplements by tag category
  const categories = { viande: [], legume: [], fromage: [], autre: [] };
  const categoryLabels = { viande: 'Viandes', legume: 'Légumes', fromage: 'Fromages', autre: 'Autres' };

  // For each supplement, find the variant matching the product size
  // Normalize: strip all spaces for reliable matching ("50 cm" → "50cm")
  var sizeName = (pizzaVariantTitle || '').toLowerCase().replace(/\s/g, '');

  supplementsToUse.forEach(function (supp) {
    var matchedVariant = supp.variants[0];
    if (sizeName && supp.variants.length > 1) {
      for (var v = 0; v < supp.variants.length; v++) {
        var suppSize = supp.variants[v].title.toLowerCase().replace(/\s/g, '');
        if (suppSize === sizeName) {
          matchedVariant = supp.variants[v];
          break;
        }
      }
    }

    var enriched = {
      id: matchedVariant.id,
      price: matchedVariant.price,
      title: supp.title,
      tags: supp.tags
    };

    let placed = false;
    if (supp.tags) {
      var tags = Array.isArray(supp.tags) ? supp.tags : [];
      for (var i = 0; i < tags.length; i++) {
        var tag = tags[i].toLowerCase();
        if (categories[tag] !== undefined) {
          categories[tag].push(enriched);
          placed = true;
          break;
        }
      }
    }
    if (!placed) categories.autre.push(enriched);
  });

  // Render each category
  Object.keys(categories).forEach(function (cat) {
    var items = categories[cat];
    if (items.length === 0) return;

    var heading = document.createElement('h3');
    heading.className = 'supplement-modal__category';
    heading.textContent = categoryLabels[cat];
    listEl.appendChild(heading);

    items.forEach(function (supp) {
      var row = document.createElement('label');
      row.className = 'supplement-item';
      row.innerHTML =
        '<input type="checkbox" class="supplement-item__checkbox" data-supp-id="' + supp.id + '" data-supp-price="' + supp.price + '" data-supp-title="' + supp.title.replace(/"/g, '&quot;') + '" onchange="updateSupplementTotal()">' +
        '<span class="supplement-item__name">' + supp.title + '</span>' +
        '<span class="supplement-item__price">+' + formatMoney(supp.price) + '</span>';
      listEl.appendChild(row);
    });
  });

  // Update total
  updateSupplementTotal();

  // Show modal
  // Clear note input
  var noteInput = document.getElementById('SupplementModalNote');
  if (noteInput) noteInput.value = '';

  modal.classList.add('supplement-modal--open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  return true;
};

window.closeSupplementModal = function () {
  const modal = document.getElementById('SupplementModal');
  if (!modal) return;
  modal.classList.remove('supplement-modal--open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
};

window.updateSupplementTotal = function () {
  var total = _supplementPizzaPrice;
  var checkboxes = document.querySelectorAll('#SupplementModalList .supplement-item__checkbox:checked');
  checkboxes.forEach(function (cb) {
    total += parseInt(cb.getAttribute('data-supp-price'), 10);
  });
  document.getElementById('SupplementModalTotal').textContent = formatMoney(total);
};

// Add pizza + selected supplements to cart
window.addWithSupplements = function () {
  var btn = document.getElementById('SupplementModalAddBtn');
  btn.disabled = true;
  btn.textContent = 'Ajout en cours...';

  var groupId = 'grp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5);
  var noteInput = document.getElementById('SupplementModalNote');
  var itemNote = noteInput ? noteInput.value.trim() : '';
  var items = [];

  // Parent pizza
  var parentProps = {
    '_group_id': groupId,
    '_group_type': 'parent'
  };
  if (itemNote) parentProps['note'] = itemNote;

  items.push({
    id: _supplementPizzaVariantId,
    quantity: 1,
    properties: parentProps
  });

  // Selected supplements
  var checkboxes = document.querySelectorAll('#SupplementModalList .supplement-item__checkbox:checked');
  checkboxes.forEach(function (cb) {
    items.push({
      id: parseInt(cb.getAttribute('data-supp-id'), 10),
      quantity: 1,
      properties: {
        '_group_id': groupId,
        '_group_type': 'supplement',
        'pour': _supplementPizzaTitle
      }
    });
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
    .then(function (r) {
      if (!r.ok) throw new Error('Erreur ajout panier');
      return r.json();
    })
    .then(function () {
      btn.disabled = false;
      btn.innerHTML = 'Ajouter au panier — <span id="SupplementModalTotal">0.00 CHF</span>';
      closeSupplementModal();
      closeProductModal();
      refreshCartDrawer();
      openCartDrawer();
      showToast('Ajouté au panier !');
    })
    .catch(function (err) {
      console.error('Add with supplements error:', err);
      btn.disabled = false;
      btn.innerHTML = 'Ajouter au panier — <span id="SupplementModalTotal">0.00 CHF</span>';
      showToast('Erreur lors de l\'ajout au panier.', 'error');
    });
};

// Add pizza without any supplements (skip)
window.addWithoutSupplements = function () {
  var btn = document.getElementById('SupplementModalAddBtn');
  btn.disabled = true;

  var noteInput = document.getElementById('SupplementModalNote');
  var itemNote = noteInput ? noteInput.value.trim() : '';
  var payload = { id: _supplementPizzaVariantId, quantity: 1 };
  if (itemNote) payload.properties = { 'note': itemNote };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
    .then(function (r) {
      if (!r.ok) throw new Error('Erreur ajout panier');
      return r.json();
    })
    .then(function () {
      btn.disabled = false;
      closeSupplementModal();
      closeProductModal();
      refreshCartDrawer();
      openCartDrawer();
      showToast('Ajouté au panier !');
    })
    .catch(function (err) {
      console.error('Add without supplements error:', err);
      btn.disabled = false;
      showToast('Erreur lors de l\'ajout au panier.', 'error');
    });
};

// Add to cart via AJAX (used by upsell section — no supplements)
window.addToCart = function (variantId, event) {
  if (event) event.stopPropagation();

  // Visual feedback on the card
  const card = event ? event.currentTarget : null;
  if (card) {
    card.classList.add('restaurant-product-card--added');
    setTimeout(() => card.classList.remove('restaurant-product-card--added'), 500);
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(response => {
      if (!response.ok) throw new Error('Erreur ajout panier');
      return response.json();
    })
    .then(() => {
      refreshCartDrawer();
      openCartDrawer();
    })
    .catch(err => {
      console.error('Add to cart error:', err);
      showToast('Erreur lors de l\'ajout au panier.', 'error');
    });
};

// Scroll upsell suggestions carousel (desktop arrows)
window.scrollUpsell = function (direction) {
  var scroll = document.querySelector('.cart-upsell__scroll');
  if (scroll) scroll.scrollBy({ left: direction * 120, behavior: 'smooth' });
};

// Add to cart from a product card — opens supplement modal if supplements exist
window.addToCartFromCard = function (cardEl, event) {
  if (event) event.stopPropagation();
  const variantId = cardEl.getAttribute('data-selected-variant');
  if (!variantId) return;

  // Try to open supplement modal (pizza collection OR per-product rule)
  var productHandle = cardEl.getAttribute('data-handle');
  var productTitle = (cardEl.querySelector('.restaurant-product-title') || {}).textContent || '';
  productTitle = productTitle.trim();
  var productPriceText = (cardEl.querySelector('.restaurant-product-price') || {}).textContent || '0';
  var productPrice = parsePriceText(productPriceText);
  var activeChip = cardEl.querySelector('.variant-chip--active');
  var variantTitle = activeChip ? activeChip.textContent.trim() : '';

  // 1) Check per-product supplement rule (frites, etc.)
  var rule = getProductSupplementRule(productHandle);
  if (rule && rule.supplements && rule.supplements.length > 0) {
    if (openSupplementModal(variantId, productTitle, productPrice, variantTitle, rule.supplements, rule.title)) return;
  }

  // 2) Fallback: pizza collection supplements
  if (hasSupplements() && cardEl.getAttribute('data-collection') === 'pizzas') {
    if (openSupplementModal(variantId, productTitle, productPrice, variantTitle)) return;
  }

  // Fallback: direct add (no supplements configured)
  cardEl.classList.add('restaurant-product-card--added');
  setTimeout(() => cardEl.classList.remove('restaurant-product-card--added'), 500);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
  })
    .then(response => {
      if (!response.ok) throw new Error('Erreur ajout panier');
      return response.json();
    })
    .then(() => {
      refreshCartDrawer();
      openCartDrawer();
    })
    .catch(err => {
      console.error('Add to cart error:', err);
      showToast('Erreur lors de l\'ajout au panier.', 'error');
    });
};

// Select a variant chip
window.selectVariant = function (chipEl) {
  const card = chipEl.closest('.restaurant-product-card');
  if (!card) return;

  // Update active chip
  const chips = card.querySelectorAll('.variant-chip');
  chips.forEach(c => c.classList.remove('variant-chip--active'));
  chipEl.classList.add('variant-chip--active');

  // Update selected variant on card
  card.setAttribute('data-selected-variant', chipEl.getAttribute('data-variant-id'));

  // Update displayed price
  const priceEl = card.querySelector('.restaurant-product-price');
  if (priceEl) {
    priceEl.textContent = chipEl.getAttribute('data-variant-price');
  }
};

// Update cart item quantity (group-aware: syncs supplements with parent pizza)
window.updateCartItem = function (line, quantity) {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var item = cart.items[line - 1];
      var groupId = item && item.properties && item.properties['_group_id'];

      if (!groupId) {
        // Simple item — no group
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        }).then(function (r) { return r.json(); });
      }

      // Find all items in this group
      var groupLines = [];
      cart.items.forEach(function (cartItem, index) {
        if (cartItem.properties && cartItem.properties['_group_id'] === groupId) {
          groupLines.push(index + 1); // 1-indexed
        }
      });

      // Sort descending for removal (to avoid index shifting)
      if (quantity === 0) {
        groupLines.sort(function (a, b) { return b - a; });
      }

      // Sequential updates for all group members
      return sequentialCartUpdates(groupLines.map(function (l) { return [l, quantity]; }), 0);
    })
    .then(function () {
      refreshCartDrawer();
    })
    .catch(function (err) {
      console.error('Update cart error:', err);
    });
};

function sequentialCartUpdates(updates, index) {
  if (index >= updates.length) return Promise.resolve();
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: updates[index][0], quantity: updates[index][1] })
  })
    .then(function (r) { return r.json(); })
    .then(function () { return sequentialCartUpdates(updates, index + 1); });
}

// Show/hide sticky cart button
function updateStickyCartBtn() {
  var btn = document.getElementById('StickyCartBtn');
  var count = document.getElementById('CartCount');
  if (!btn) return;
  var itemCount = count ? parseInt(count.textContent, 10) : 0;
  btn.style.display = itemCount > 0 ? 'flex' : 'none';
}

// Refresh cart drawer content via section rendering
function refreshCartDrawer() {
  fetch('/?sections=header')
    .then(res => res.json())
    .then(data => {
      const html = data['header'];
      if (!html) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update cart items
      const newItems = doc.getElementById('CartDrawerItems');
      const currentItems = document.getElementById('CartDrawerItems');
      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
      }

      // Update cart footer
      const newFooter = doc.getElementById('CartDrawerFooter');
      const currentFooter = document.getElementById('CartDrawerFooter');
      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
        currentFooter.style.display = newFooter.style.display;
      }

      // Update cart count badge
      const newCount = doc.getElementById('CartCount');
      const currentCount = document.getElementById('CartCount');
      if (newCount && currentCount) {
        currentCount.textContent = newCount.textContent;
      }

      // Update sticky cart button from cart.js
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var stickyTotal = document.getElementById('StickyCartTotal');
          var stickyCount = document.getElementById('StickyCartCount');
          if (stickyTotal) stickyTotal.textContent = formatMoney(cart.total_price);
          if (stickyCount) stickyCount.textContent = cart.item_count;
          updateStickyCartBtn();
          updateMinOrderBar();
        });
    })
    .catch(err => {
      console.error('Refresh cart error:', err);
    });
}

// ========== Product Detail Modal ==========
let _modalSelectedVariantId = null;
let _modalIsPizza = false;
let _modalProductHandle = null;

window.openProductModal = function (handle, collectionHandle) {
  const modal = document.getElementById('ProductModal');
  if (!modal) return;

  // Reset
  document.getElementById('ProductModalImage').innerHTML = '<div style="padding:2rem;color:var(--color-muted);">Chargement...</div>';
  document.getElementById('ProductModalTitle').textContent = '';
  document.getElementById('ProductModalPrice').textContent = '';
  document.getElementById('ProductModalDesc').innerHTML = '';
  document.getElementById('ProductModalVariants').innerHTML = '';
  _modalSelectedVariantId = null;
  _modalIsPizza = (collectionHandle === 'pizzas');
  _modalProductHandle = handle;

  // Show modal
  modal.classList.add('product-modal--open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';

  // Fetch product
  fetch('/products/' + handle + '.js')
    .then(r => r.json())
    .then(product => {
      // Image
      const imgEl = document.getElementById('ProductModalImage');
      if (product.featured_image) {
        imgEl.innerHTML = '<img src="' + product.featured_image.replace(/\.([a-z]+)$/i, '_600x.$1') + '" alt="' + product.title + '">';
      } else {
        imgEl.innerHTML = '<img src="https://placehold.co/600x600/f5f5f5/999?text=L\'image+arrive+bient%C3%B4t!" alt="' + product.title + '" style="width:100%;">';
      }

      // Title, price, description
      document.getElementById('ProductModalTitle').textContent = product.title;

      const firstVariant = product.variants[0];
      _modalSelectedVariantId = firstVariant.id;
      document.getElementById('ProductModalPrice').textContent = formatMoney(firstVariant.price);

      document.getElementById('ProductModalDesc').innerHTML = product.description || '';

      // Variants
      if (product.variants.length > 1) {
        const container = document.getElementById('ProductModalVariants');
        product.variants.forEach(function (v, i) {
          const chip = document.createElement('button');
          chip.className = 'product-modal__variant-chip' + (i === 0 ? ' product-modal__variant-chip--active' : '');
          chip.textContent = v.title;
          chip.setAttribute('data-variant-id', v.id);
          chip.setAttribute('data-variant-price', v.price);
          chip.onclick = function () { selectModalVariant(chip); };
          container.appendChild(chip);
        });
      }
    })
    .catch(err => {
      console.error('Product fetch error:', err);
      document.getElementById('ProductModalTitle').textContent = 'Erreur de chargement';
    });
};

window.closeProductModal = function () {
  const modal = document.getElementById('ProductModal');
  if (!modal) return;
  modal.classList.remove('product-modal--open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
};

window.selectModalVariant = function (chipEl) {
  const container = chipEl.parentElement;
  container.querySelectorAll('.product-modal__variant-chip').forEach(function (c) {
    c.classList.remove('product-modal__variant-chip--active');
  });
  chipEl.classList.add('product-modal__variant-chip--active');
  _modalSelectedVariantId = parseInt(chipEl.getAttribute('data-variant-id'), 10);
  document.getElementById('ProductModalPrice').textContent = formatMoney(parseInt(chipEl.getAttribute('data-variant-price'), 10));
};

window.addFromModal = function () {
  if (!_modalSelectedVariantId) return;

  // Try to open supplement modal (per-product rule OR pizza collection)
  var title = document.getElementById('ProductModalTitle').textContent.trim();
  var price = parsePriceText(document.getElementById('ProductModalPrice').textContent);
  var activeModalChip = document.querySelector('.product-modal__variant-chip--active');
  var variantTitle = activeModalChip ? activeModalChip.textContent.trim() : '';

  // 1) Check per-product supplement rule
  var rule = getProductSupplementRule(_modalProductHandle);
  if (rule && rule.supplements && rule.supplements.length > 0) {
    if (openSupplementModal(_modalSelectedVariantId, title, price, variantTitle, rule.supplements, rule.title)) return;
  }

  // 2) Fallback: pizza collection supplements
  if (hasSupplements() && _modalIsPizza) {
    if (openSupplementModal(_modalSelectedVariantId, title, price, variantTitle)) return;
  }

  // Fallback: direct add (no supplements configured)
  const btn = document.getElementById('ProductModalAddBtn');
  btn.disabled = true;
  btn.textContent = 'Ajout en cours...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: _modalSelectedVariantId, quantity: 1 })
  })
    .then(r => {
      if (!r.ok) throw new Error('Erreur');
      return r.json();
    })
    .then(() => {
      btn.disabled = false;
      btn.textContent = 'Ajouter au panier';
      closeProductModal();
      refreshCartDrawer();
      openCartDrawer();
    })
    .catch(err => {
      console.error('Add from modal error:', err);
      btn.disabled = false;
      btn.textContent = 'Ajouter au panier';
      showToast('Erreur lors de l\'ajout au panier.', 'error');
    });
};

// Format Shopify price (in cents) to display format
function formatMoney(cents) {
  return (cents / 100).toFixed(2) + ' CHF';
}

// Parse display price text (e.g., "22.00 CHF") back to cents (2200)
function parsePriceText(text) {
  var match = text.match(/(\d+[.,]\d+|\d+)/);
  if (!match) return 0;
  return Math.round(parseFloat(match[1].replace(',', '.')) * 100);
}

// ========== Hash-based navigation ==========
(function () {
  function handleHash() {
    var hash = window.location.hash.replace('#', '').toLowerCase();
    if (hash === 'livraison') {
      var dropdown = document.getElementById('DeliveryZonesDropdown');
      if (dropdown && !dropdown.classList.contains('delivery-dropdown--open')) {
        window.toggleDeliveryZones();
      }
    }
  }
  window.addEventListener('hashchange', handleHash);
  if (window.location.hash) {
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', handleHash)
      : handleHash();
  }
})();

// ========== Checkout Preparation (clean properties for admin) ==========

// Build cleaned cart items + formatted summary for the order note
function buildCleanedCart(cart) {
  var groups = {};
  var ungrouped = [];

  cart.items.forEach(function (item) {
    var gid = item.properties && item.properties['_group_id'];
    if (!gid) {
      ungrouped.push(item);
      return;
    }
    if (!groups[gid]) groups[gid] = { parent: null, supplements: [] };
    if (item.properties['_group_type'] === 'parent') {
      groups[gid].parent = item;
    } else {
      groups[gid].supplements.push(item);
    }
  });

  var cleanedItems = [];
  var summaryLines = [];

  // Process grouped items
  Object.keys(groups).forEach(function (gid) {
    var group = groups[gid];
    if (!group.parent) {
      // Orphan supplements — add as ungrouped
      group.supplements.forEach(function (s) { ungrouped.push(s); });
      return;
    }

    var parent = group.parent;
    var suppNames = group.supplements.map(function (s) { return s.product_title; });

    // Clean parent properties
    var parentProps = {};
    if (parent.properties && parent.properties['note']) {
      parentProps['Note'] = parent.properties['note'];
    }
    if (suppNames.length > 0) {
      parentProps['Supplements'] = suppNames.join(', ');
    }

    cleanedItems.push({
      id: parent.variant_id,
      quantity: parent.quantity,
      properties: parentProps
    });

    // Clean supplement properties
    group.supplements.forEach(function (supp) {
      var parentLabel = parent.product_title;
      if (parent.variant_title && parent.variant_title !== 'Default Title') {
        parentLabel += ' (' + parent.variant_title + ')';
      }
      cleanedItems.push({
        id: supp.variant_id,
        quantity: supp.quantity,
        properties: { 'Supplement pour': parentLabel }
      });
    });

    // Summary line
    var line = parent.quantity + 'x ' + parent.product_title;
    if (parent.variant_title && parent.variant_title !== 'Default Title') {
      line += ' (' + parent.variant_title + ')';
    }
    if (parent.properties && parent.properties['note']) {
      line += ' [' + parent.properties['note'] + ']';
    }
    summaryLines.push(line);
    suppNames.forEach(function (name) {
      summaryLines.push('   + ' + name);
    });
  });

  // Process ungrouped items
  ungrouped.forEach(function (item) {
    var props = {};
    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        if (key.charAt(0) !== '_') {
          props[key] = item.properties[key];
        }
      });
    }
    cleanedItems.push({
      id: item.variant_id,
      quantity: item.quantity,
      properties: Object.keys(props).length > 0 ? props : {}
    });

    var line = item.quantity + 'x ' + item.product_title;
    if (item.variant_title && item.variant_title !== 'Default Title') {
      line += ' (' + item.variant_title + ')';
    }
    summaryLines.push(line);
  });

  return {
    items: cleanedItems,
    summary: summaryLines.length > 0 ? 'DETAIL COMMANDE:\n' + summaryLines.join('\n') : ''
  };
}

// Add items in batches of 20 (Shopify limit)
function addItemsInBatches(items) {
  var batchSize = 20;
  var batches = [];
  for (var i = 0; i < items.length; i += batchSize) {
    batches.push(items.slice(i, i + batchSize));
  }
  function addBatch(index) {
    if (index >= batches.length) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: batches[index] })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('add batch ' + index + ' failed');
      return r.json();
    })
    .then(function () { return addBatch(index + 1); });
  }
  return addBatch(0);
}

// Rollback: restore original cart if checkout preparation fails
function restoreCart(originalCart, triggerEl, originalText) {
  var items = originalCart.items.map(function (item) {
    return {
      id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties || {}
    };
  });

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  .then(function () { return addItemsInBatches(items); })
  .then(function () {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: originalCart.note || '' })
    });
  })
  .then(function () {
    showToast('Erreur lors de la preparation. Votre panier a ete restaure.', 'error');
    resetCheckoutButton(triggerEl, originalText);
  })
  .catch(function () {
    showToast('Erreur critique. Veuillez rafraichir la page.', 'error');
    resetCheckoutButton(triggerEl, originalText);
  });
}

function resetCheckoutButton(el, text) {
  if (el) {
    el.textContent = text;
    el.disabled = false;
    el.style.pointerEvents = '';
  }
  window._checkoutInProgress = false;
}

// Main checkout preparation: clean properties + build summary note
window.prepareCheckout = function (triggerEl) {
  if (window._checkoutInProgress) return;
  window._checkoutInProgress = true;

  var originalText = triggerEl ? triggerEl.textContent : '';
  if (triggerEl) {
    triggerEl.textContent = 'Preparation...';
    triggerEl.disabled = true;
    triggerEl.style.pointerEvents = 'none';
  }

  // Capture customer note from cart page textarea (if present)
  var customerNote = '';
  var noteEl = document.getElementById('CartNote');
  if (noteEl) customerNote = noteEl.value.trim();

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (!cart.items || cart.items.length === 0) {
        window._checkoutInProgress = false;
        window.location.href = '/cart';
        return;
      }

      // Check if any items have group properties
      var hasGroups = cart.items.some(function (item) {
        return item.properties && item.properties['_group_id'];
      });

      if (!hasGroups) {
        // No groups: just update note if needed and redirect
        var note = customerNote || cart.note || '';
        if (note !== (cart.note || '')) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note })
          })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { window.location.href = '/checkout'; });
        } else {
          window.location.href = '/checkout';
        }
        return;
      }

      // Build cleaned cart
      var result = buildCleanedCart(cart);
      var cleanedItems = result.items;
      var summaryText = result.summary;

      // Compose final note
      var finalNote = customerNote || cart.note || '';
      if (summaryText) {
        if (finalNote) finalNote += '\n\n---\n\n';
        finalNote += summaryText;
      }

      var originalCart = cart;

      // Clear -> Re-add -> Update note -> Redirect
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function (r) {
        if (!r.ok) throw new Error('clear failed');
        return r.json();
      })
      .then(function () { return addItemsInBatches(cleanedItems); })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: finalNote })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('note update failed');
        return r.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('Checkout preparation failed:', err);
        restoreCart(originalCart, triggerEl, originalText);
      });
    })
    .catch(function (err) {
      console.error('Failed to fetch cart:', err);
      resetCheckoutButton(triggerEl, originalText);
    });
};

